import Icon from '../components/Icon.vue'

Icon.register({
  'search-dollar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 442.7L405.3 343C400.8 338.5 394.7 336 388.3 336H372C399.6 300.7 416 256.3 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416C256.3 416 300.7 399.6 336 372V388.3C336 394.7 338.5 400.8 343 405.3L442.7 504.9C452.1 514.4 467.3 514.4 476.6 504.9L504.9 476.6C514.3 467.3 514.3 452.1 505 442.7zM208 352C128.5 352 64 287.6 64 208 64 128.4 128.4 64 208 64 287.6 64 352 128.3 352 208 352 287.5 287.7 352 208 352zM235.1 199.4L190.1 185.9C185 184.4 181.4 179.1 181.4 173.2 181.4 165.9 186.7 160 193.2 160H221.3C225.8 160 230.2 161.3 234.1 163.7 237.3 165.8 241.4 165.6 244.2 163L256 151.8C259.5 148.4 259.3 142.6 255.4 139.6 246.3 132.8 235.3 128.9 224 128.3V112C224 107.6 220.4 104 216 104H200C195.6 104 192 107.6 192 112V128.1C168.4 128.8 149.3 148.7 149.3 173.2 149.3 193.2 162.3 211 180.9 216.6L225.9 230.1C231.1 231.6 234.7 236.9 234.7 242.8 234.7 250.1 229.4 256 222.9 256H194.8C190.2 256 185.8 254.7 182 252.3 178.7 250.3 174.6 250.4 171.8 253L160.1 264.2C156.6 267.6 156.8 273.4 160.7 276.4 169.8 283.2 180.8 287.1 192 287.7V304C192 308.4 195.6 312 200 312H216C220.5 312 224 308.4 224 304V287.9C247.7 287.3 266.7 267.3 266.7 242.8 266.7 222.8 253.7 205 235.1 199.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/search-dollar.js
// module id = dtQ7
// module chunks = 144